import React from 'react';
import styled from '@emotion/styled';
import { Tooltip } from '@mantine/core';
import { Theme } from '@seedlang/constants';

const Wrapper = styled.span`
  position: ${props => props.position};
  top: ${props => props.top};
  left: ${props => props.left};
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 5px;
    background: ${Theme.lightGray};
    transition: background 0.15s ease;
    color: inherit;
    cursor: pointer;
  }
  button:not(:disabled):hover {
    background: #e2e2e2;
  }
  button:not(:disabled):active {
    background: #e5e5e5;
  }
  button:disabled {
    opacity: 0.3;
    cursor: default;
  }
  font-size: 12px;
`;

export default function WordNavigation({ loading, canNavigate, onNavigate, label = 'Dictionary navigation', top = '10px', left = '10px', position = 'absolute', wordLabel }) {
  if (loading || (!canNavigate(-1) && !canNavigate(1))) return null;
  return (
    <Wrapper position={position} top={top} left={left} aria-label={label} aria-busy={loading}>
      {[-1, 1].map(direction => {
        const label = direction === -1 ? 'Previous word' : 'Next word';
        const target = wordLabel?.(direction);
        const title = target ? `${label}: ${target}` : label;
        return (
          <Tooltip key={direction} label={title} withinPortal withArrow events={{ hover: true, focus: true, touch: true }}>
            <button
              type='button'
              disabled={loading || !canNavigate(direction)}
              onClick={() => onNavigate(direction)}
              aria-label={title}
            >
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' aria-hidden='true'>
                <path d={direction === -1 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'} />
              </svg>
            </button>
          </Tooltip>
        );
      })}
    </Wrapper>
  );
}
